<!-- <template>
  <v-row dense>
    <v-col cols="12">
      <v-card flat :loading="carregando" rounded="lg">
        <v-card-subtitle class="font-weight-bold black--text subtitle-1"
          >Atalhos rápidos</v-card-subtitle
        >
        <v-card-text>
          <v-row :dense="isMobile()">
            <v-col
              xl="auto"
              lg="2"
              md="3"
              sm="6"
              cols="6"
              v-for="(atalho, i) in getAtalhos()"
              :key="i"
            >
              <v-card
                color="green lighten-5"
                hover
                outlined
                class="h-100 rounded-lg"
                :min-width="isMobile() ? 0 : 200"
                max-width="200"
                :to="{ name: atalho.link }"
              >
                <v-card-text class="text-center">
                  <v-row>
                    <v-col>
                      <v-icon color="primary" :size="isMobile() ? 30 : 45">{{
                        atalho.icone
                      }}</v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col
                      cols="12"
                      class="primary--text font-weight-bold subtitle-1"
                    >
                      {{ atalho.descricao }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  computed: mapState("usuario", ["gerencial"]),
  data: () => ({
    carregando: false,
    atalhos: [],
  }),
  methods: {
    async carregarAtalhos() {
      this.carregando = true;
      this.atalhos = [];

      await axios
        .get(`/colaborador/modulos?funcao=ATALHOS-RAPIDOS`)
        .then((res) => {
          if (res.data.success) {
            console.log("ATALHO RAPIDO", res.data.data);
            this.atalhos = res.data.data;
          }
        });
      this.carregando = false;
    },
    getAtalhos() {
      return this.atalhos;
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async created() {
    await this.carregarAtalhos();
  },
};
</script>

<style></style> -->

<template>
  <v-row dense>
    <v-col cols="12">
      <v-card flat :loading="carregando" rounded="lg">
        <v-card-subtitle class="font-weight-bold black--text subtitle-1"
          >Atalhos rapidos</v-card-subtitle
        >
        <v-card-text>
          <v-row :dense="isMobile()">
            <v-col
              xl="auto"
              lg="2"
              md="3"
              sm="6"
              cols="6"
              v-for="(atalho, i) in getAtalhos()"
              :key="i"
            >
              <v-card
                color="green lighten-5"
                hover
                outlined
                class="h-100 rounded-lg"
                :min-width="isMobile() ? 0 : 200"
                max-width="200"
                :loading="processandoDeclaracao && isDeclaracaoEmprego(atalho)"
                @click="handleAtalhoClick(atalho)"
              >
                <v-card-text class="text-center">
                  <v-row>
                    <v-col>
                      <v-icon color="primary" :size="isMobile() ? 30 : 45">{{
                        atalho.icone
                      }}</v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col
                      cols="12"
                      class="primary--text font-weight-bold subtitle-1"
                    >
                      {{ atalho.descricao }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { dateFormat, getLinkImpressao, getToken } from "@/global";

export default {
  computed: mapState("usuario", ["gerencial"]),
  data: () => ({
    carregando: false,
    atalhos: [],
    processandoDeclaracao: false,
  }),
  methods: {
    async carregarAtalhos() {
      this.carregando = true;
      this.atalhos = [];

      await axios
        .get(`/colaborador/modulos?funcao=ATALHOS-RAPIDOS`)
        .then((res) => {
          if (res.data.success) {
            this.atalhos = res.data.data;
          }
        });
      this.carregando = false;
    },
    getAtalhos() {
      return this.atalhos;
    },
    isMobile() {
      return this.$mq == "sm";
    },
    async handleAtalhoClick(atalho) {
      if (!atalho) return;

      if (this.isDeclaracaoEmprego(atalho)) {
        if (!this.processandoDeclaracao) {
          await this.processarDeclaracaoEmprego();
        }
        return;
      }

      if (atalho.link) {
        this.$router.push({ name: atalho.link });
      }
    },
    isDeclaracaoEmprego(atalho) {
      const descricao = this.normalizarTexto(atalho?.descricao);
      return descricao === "declaracao de emprego";
    },
    normalizarTexto(texto) {
      if (!texto) return "";
      return texto
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    async processarDeclaracaoEmprego() {
      this.processandoDeclaracao = true;
      try {
        let declaracao = await this.buscarDeclaracaoEmprego();

        if (!declaracao || !declaracao.id || declaracao.id <= 0) {
          const emitiu = await this.emitirDeclaracaoEmprego();
          if (!emitiu) return;
          declaracao = await this.buscarDeclaracaoEmprego();
        }

        if (declaracao && declaracao.id > 0) {
          this.exibirDeclaracaoInfo(declaracao);
          this.abrirDeclaracaoPDF();
        } else {
          this.$toasted.info("Nenhuma declaracao emitida.");
        }
      } finally {
        this.processandoDeclaracao = false;
      }
    },
    async buscarDeclaracaoEmprego() {
      try {
        const res = await axios.get(`colaborador/convenios?funcao=DECLARACAO`);
        return res.data?.success ? res.data.data : null;
      } catch (e) {
        this.$toasted.error(
          `Houve um erro ao carregar a declaracao. ${e?.message || e}`
        );
        return null;
      }
    },
    async emitirDeclaracaoEmprego() {
      try {
        const res = await axios.post(
          `colaborador/convenios?funcao=EMITIR-DECLARACAO`
        );
        if (res.data?.success) {
          return true;
        }
        this.$toasted.error(res.data?.msg || "Falha ao emitir a declaracao.");
      } catch (e) {
        this.$toasted.error(
          `Houve um erro ao emitir a declaracao. ${e?.message || e}`
        );
      }
      return false;
    },
    exibirDeclaracaoInfo(declaracao) {
      if (!declaracao || !declaracao.id) return;
      const validade = declaracao.validade
        ? ` valida ate ${dateFormat(declaracao.validade)}`
        : "";
      this.$toasted.info(`Declaracao n. ${declaracao.id}${validade}.`);
    },
    abrirDeclaracaoPDF() {
      window.open(
        `${getLinkImpressao()}/declaracao-convenio-pdf.php?token=${getToken()}`,
        "_blank"
      );
    },
  },
  async created() {
    await this.carregarAtalhos();
  },
};
</script>

<style></style>
